var $ = require('jquery'),
  gc = require('./js/gc'),
  mode = require('./js/mode'),
  ls = require('local-storage'),
  Video = require('./js/video'),
  Mode = require('./js/mode'),
  social = require('./js/social'),
  FontFaceObserver = require('fontfaceobserver'),
  $w = $(window),
  $b = $('body');

require('./js/track');
//require('./js/section-sectors');
//require('./js/section-investments');

require('./js/world');

gc.where('body[data-build]', function($b){
  (new FontFaceObserver('glyphs-'+$b.data('build')))
  .load().then(function () {
    $b.addClass('glyphs-loaded');
  });
})

gc.where('.overlay', function($overlay){
  $overlay.click(mode.clear);
});

$w.on('gc:scrolling', function(e, st){
  $b[ st > 10  ? 'addClass' : 'removeClass']('scroll');
  $b[gc.scrollDirection.up ? 'addClass' : 'removeClass']('scroll-up');
});

$w.on('resize', function () {
  var vh = (window.innerHeight - ($('.toolbar-spacer').height() || 0)) * 0.01;
  document.documentElement.style.setProperty('--vh', vh+'px');
}).trigger('resize');

gc.when('figure[data-background]', function( $el ){

  var $th = $(this);

  if(!$('.img-bg-loader', $th).length)
    $th.append($('<div class="img-bg-loader"></div>'));

  $th.addClass('loading');

  $th.on('appear', function(){

    if(!$th.hasClass('loaded')){

      var img = new Image;

      $(img).bind('load error', function(e){
        $th.css('background-image', 'url('+$th.attr('src')+')')
          .addClass('loaded')
          .removeClass('loading');

        setTimeout(function(){
          $('.img-bg-loader', $th).remove();
        }, 1000);
      });

      img.src = $th.attr('src');
    }
  });

  $th.track(null, null, true);
});

gc.when('button.toolbar-icon-edit', function($button){
  $button.click(function(){
    $('body').toggleClass('edit-mode');
  });
  if($(window).width() >= 976)
    $('#toolbar-item-administration')[0].click();
});

/* Keep deleting 'Drupal.toolbar.activeTabID' so we don't get the arsehole when resizing window */

setInterval(function(){
  ls.remove('Drupal.toolbar.activeTabID');
}, 1000);

gc.where('body.slug-measurement article.display-full .field--name-field-paragraphs', function($para){

  var $items = $('> .field--item', $para),
    $screen = $('<div class="screen measurement-detail ht"><div class="wrapper"><div class="detail"></div></div></div>');

  $para.append($screen);
  $detail = $('.detail', $screen);

  $items.each(function(n){;

    var $item = $(this);

    $item.click(function(){
      if($items[n+1]){
        var $next = $items.eq(n+1);
        $next.show();
        $("html, body").animate({ scrollTop: $next.offset().top - 200 }, 500);
      }
    });

    var $btn = $('<div class="button-wrapper"><button class="read-more">Find out more</button></div>');

    $btn.click(function(e){
      e.stopPropagation();
      var $block = $('blockquote', $item);
      $detail.html('<div class="close-button"><button class="close">×</button></div>');
      $detail.append($block.clone());
      Mode.set('measurement-detail');
      $('.close-button', $detail).click(function(){
        Mode.clear();
      });
    });

    $item.append($btn);
  });
});


gc.where('.paragraph--type--vimeo', function($p){
  var href = $('.video-link a', $p).attr('href');
  $p.attr('data-video-url', href);
  Video.createPlayer($p);
});

gc.where('.share-methods a[data-network]', function($a){
  $a.on('click', social.clickHandler);
});



//////////////////
// WEBPACK FOOTER
// ./themes/gc/rise.js
// module id = 0
// module chunks = 0